import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  PropsWithChildren,
} from "react";

type AnnouncementType = "info" | "success" | "error" | "warning";

interface AnnouncementState {
  type: AnnouncementType;
  message: string;
}

interface AnnouncementContextType {
  announcement: AnnouncementState | null;
  showAnnouncement: (type: AnnouncementType, message: string) => void;
  closeAnnouncement: () => void;
}

const AnnouncementContext = createContext<AnnouncementContextType>({
  announcement: null,
  showAnnouncement: () => {},
  closeAnnouncement: () => {},
});

export const AnnouncementProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [announcement, setAnnouncement] = useState<AnnouncementState | null>(
    null
  );

  const showAnnouncement = useCallback(
    (type: AnnouncementType, message: string) => {
      setAnnouncement({ type, message });
    },
    []
  );

  const closeAnnouncement = useCallback(() => {
    setAnnouncement(null);
  }, []);

  return (
    <AnnouncementContext.Provider
      value={{ announcement, showAnnouncement, closeAnnouncement }}
    >
      {children}
    </AnnouncementContext.Provider>
  );
};

export const useAnnouncementContext = () => useContext(AnnouncementContext);
